import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-simple-unauth',
  imports: [RouterOutlet],
  templateUrl: './simple-unauth.component.html',
  styleUrl: './simple-unauth.component.css'
})
export class SimpleUnauthComponent {

}
